export default defineNuxtRouteMiddleware(async () => {
  const { $localePath: localePath } = useNuxtApp();
  const route = useRoute();
  const authStore = useAuthStore();
  const partnerStore = usePartnerStore();
  if(route.params.partner){
    await partnerStore.getDetailData(route.params.partner as string);
  }
  if (partnerStore.partner && !partnerStore.partner.is_online_buyout && (authStore.data?.partner.id !== partnerStore.partner.id)) {
    partnerStore.partner = null;
    return navigateTo(localePath({ name: "index" }));
  }
});
